import { trackSessionStatusUpdated } from '@/models/analytics/features/trackSessionLifecycleAnalytics';
import { useMutateUpdateSessionStatus as useMutateUpdateSessionStatusCore } from '@heidi/session/data';

export const useMutateUpdateSessionStatus = () =>
  useMutateUpdateSessionStatusCore({
    onStatusUpdated: ({ sessionId, sessionStatus }) =>
      trackSessionStatusUpdated({ sessionId, sessionStatus }),
  });
